import Styled from 'styled-components';

export const TableRowCalculationsHeader = Styled.div`
display: flex;
justify-content: stretch;
align-items: center;
background: white;
/* width: auto; */
z-index:3;
${props => (props.stickyTopPosition !== null ? 'position:sticky;' : '')};
${props => (props.stickyTopPosition !== null ? 'top: 0px;' : '')};
padding-left: ${({numberOfGroupings}) =>
	numberOfGroupings === 1 ? '48px;' : numberOfGroupings === 2 ? '92px;' : numberOfGroupings === 0 && '16px;'};
`;

export const BaseLevelSpaceHeaderStyle = Styled.div`
flex: 1;
box-sizing: border-box;
`;

export const BaseLevelCalculationsHeaderStyle = Styled.div`
display:flex;
flex-direction: column;
box-sizing: border-box;
padding-bottom: 8px;
align-items: flex-end;
justify-content: flex-start;
height: 36px;
width: 166px;
background: white;
color: #a1a1a1;
font-weight: 400;
line-height: 1.22;
font-size: 9px;
padding-left: 16px;
padding-right: 16px;
order: ${props => props.order};
div:first-child {
    display: flex;
    flex-direction: row;
    ${props =>
		props.sortItem !== false
			? `&:hover {
    cursor: pointer;
    color:#6e0fea;
    font-weight: 500;
       }`
			: ''};
${props =>
	props.isSorting !== null
		? ` 
    cursor: pointer; 
    color:#6e0fea;
    font-weight: 500;  `
		: ''};
}
`;

export const BaseLevelOnlyTextHeaderStyle = Styled.div`
display:flex;
flex-direction: column;
box-sizing: border-box;
padding-bottom: 8px;
align-items: flex-start;
justify-content: flex-start;
height: 36px;
width: 166px;
background: white;
color: #a1a1a1;
font-weight: 400;
line-height: 1.22;
font-size: 9px;
order: ${props => props.order};
div {
    display: flex;
    flex-direction: row;
    ${props =>
		props.sortItem !== false
			? `&:hover {
    cursor: pointer;
    color:#6e0fea;
    font-weight: 500;
       }`
			: ''};
${props =>
	props.isSorting !== null
		? ` 
    cursor: pointer; 
    color:#6e0fea;
    font-weight: 500;  `
		: ''};
}

`;

export const BaseLevelCalculationsHeaderDetailStyle = Styled.div`
display:grid;
flex:1;
min-width: 166px;
box-sizing: border-box;
padding-bottom: 8px;
align-items: flex-start;
justify-content: flex-start;
height: 36px;
font-size: 9px;
background: white;
color: #a1a1a1;
order: ${props => props.order};
font-weight: 400;
line-height: 1.22;
letter-spacing: 0;
div {
    display: flex;
    flex-direction: row;
    ${props =>
		props.sortItem !== false
			? `&:hover {
    cursor: pointer;
    color:#6e0fea;
    font-weight: 500;
       }`
			: ''};
${props =>
	props.isSorting !== null
		? ` 
    cursor: pointer; 
    color:#6e0fea;
    font-weight: 500;  `
		: ''};
}
`;

export const Title = Styled.div`
font-size: 9px;
font-weight: 500;
padding-bottom: 3px;
text-transform: uppercase;
letter-spacing: 1px;
`;

export const Calculation = Styled.div`
font-size: 13px;
font-weight: 500;
padding-bottom: 8px;
color: #080927;
letter-spacing: 0px;
`;
